export class ListAzureKeyVaultKeysResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "keys",
            "baseName": "keys",
            "type": "Array<AzureKeyVaultKey>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureKeyVaultKeysResponse.attributeTypeMap;
    }
    constructor() {
    }
}
